/**
 * "127 değerlendirme" satırını yorumlara giden bağlantıya çevirir.
 *
 * Neden JS: yıldız satırını Horizon'un çekirdek `review` bloğu basıyor ve o
 * bloğa dokunmuyoruz (tema güncellemesinde geri gelir). Blok sayıyı düz <p>
 * olarak yazıyor; referans tasarımda ise altı çizili bir bağlantı ve puanı
 * gören müşteriyi doğrudan yorumlara indiriyor.
 *
 * Hedef bulunamazsa bağlantı KURULMAZ — yorum bölümü kaldırılmış bir sayfada
 * hiçbir yere gitmeyen bir bağlantı bırakmak, düz metin bırakmaktan kötüdür.
 *
 * Judge.me widget'ı kendi bölümünü asenkron doldurduğu için bölüm kabuğu
 * (templates/product.json içindeki `judgeme_reviews`) sayfa açılışında zaten
 * DOM'da; ayrıca beklemeye gerek yok.
 */
/**
 * Sirali aday listesi. Ilk sirada KENDI yorum bolumumuz var
 * (sections/yg-reviews.liquid, id="yg-yorumlar"); Judge.me'nin kendi widget'i
 * artik CSS ile gizli, yalniz yorum yazma formunu tasidigi icin duruyor.
 *
 * GORUNURLUK SARTI: aday sadece DOM'da olmasi yetmez, GORUNUR de olmali.
 * Bu sart olmadan bagli kalindiginda su oldu — gizli widget hala DOM'daydi,
 * baglanti ona isaret ediyordu ve tiklaninca hicbir sey olmuyordu.
 */
const YG_HEDEFLER = [
  '#yg-yorumlar',
  '#shopify-section-judgeme_reviews',
  '.jdgm-rev-widget',
  '#judgeme_product_reviews',
];

function ygGorunur(el) {
  if (!el) return false;
  if (el.offsetParent !== null) return true;
  // position:fixed elemanlarda offsetParent null olur; kutu olcusune bak.
  const r = el.getBoundingClientRect();
  return r.width > 0 || r.height > 0;
}

function ygYorumBaglantisi() {
  const sayac = document.querySelector('.product-details .rating-count');
  if (!sayac || sayac.tagName === 'A') return;

  const hedef = YG_HEDEFLER.map((s) => document.querySelector(s)).find(ygGorunur);
  if (!hedef) return;

  if (!hedef.id) hedef.id = 'yg-yorumlar';

  const bag = document.createElement('a');
  bag.className = sayac.className;
  bag.href = `#${hedef.id}`;
  bag.replaceChildren(...sayac.childNodes);
  sayac.replaceWith(bag);

  // Kaydırmayı TARAYICI yapıyor, JS değil.
  //
  // Önce burada preventDefault + scrollIntoView vardı; gerekçesi "sayfa
  // .page-wrapper içinde kaydığı için tarayıcının kendi hash atlaması sabit
  // header'ın altında kalıyor" idi. O gerekçe assets/yg-base.css'e
  // scroll-margin-block-start eklenmeden önce geçerliydi. Ölçüldü: scroll-margin
  // yerindeyken tarayıcının kendi atlaması hedefi header'ın 85px altına
  // bırakıyor, yani doğru.
  //
  // Elle kaydırma ayrıca kare üretimine bağımlıydı: smooth animasyon kare
  // gelmeyince hiç başlamıyor ve tıklama tepkisiz görünüyordu. Tarayıcının
  // kendi atlaması bu sorundan muaf.
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', ygYorumBaglantisi, { once: true });
} else {
  ygYorumBaglantisi();
}
